import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bold", "checked", "disabled", "id", "indeterminate", "fontSize", "label", "description", "descriptionType", "overflow"];
import "core-js/modules/es.string.bold.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox';
import Flex, { Box } from 'components/Flex';
import useUniqueId from 'hooks/useUniqueId';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import { pxToRem } from 'utils/ui';
// These styles center the checkbox vertically next to the first line of
// its label, so that even when the label runs across multiple lines
// or changes its font size, it will be aligned correctly.
// To make this work, the line height needed to be hard-coded, but in the
// future, this should be updated to use the `lh` unit which always reflects
// the current line-height).

var CentredCheckbox = styled(Checkbox).withConfig({
  displayName: "CheckboxOption__CentredCheckbox",
  componentId: "sc-1v5wwne-0"
})(["position:relative;top:calc(1em * ", " / 2);margin:0 ", ";transform:translateY(-50%);"], function (p) {
  return p.theme.globals.lineHeight;
}, pxToRem(2));
function getCheckboxSize(fontSize) {
  if (fontSize === 'xxs' || fontSize === 'xs' || fontSize === 's' || fontSize === 'm') {
    return 'small';
  } else {
    return 'default';
  }
}
var CheckboxOption = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    checked = _ref.checked,
    disabled = _ref.disabled,
    id = _ref.id,
    indeterminate = _ref.indeterminate,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'm' : _ref$fontSize,
    label = _ref.label,
    description = _ref.description,
    _ref$descriptionType = _ref.descriptionType,
    descriptionType = _ref$descriptionType === void 0 ? 'tooltip' : _ref$descriptionType,
    overflow = _ref.overflow,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uniqueId = useUniqueId(id);
  var isBold = bold === true || bold === 'auto' && !disabled && (checked || indeterminate);
  var descriptionId = description ? "".concat(uniqueId, "-desc") : undefined;
  return /*#__PURE__*/React.createElement(Flex, {
    align: "top",
    fontSize: fontSize,
    dimmed: disabled,
    bold: isBold
  }, /*#__PURE__*/React.createElement(CentredCheckbox, _extends({}, otherProps, {
    id: uniqueId,
    ref: ref,
    disabled: disabled,
    checked: checked,
    indeterminate: indeterminate,
    size: getCheckboxSize(fontSize),
    "aria-describedby": descriptionId
  })), /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    overflow: overflow,
    ml: "xs"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: uniqueId
  }, label), description && (descriptionType === 'tooltip' ? /*#__PURE__*/React.createElement(HintTooltip, {
    content: description,
    id: descriptionId,
    spacingLeft: "xxs"
  }) : /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "s",
    bold: false,
    id: descriptionId
  }, description))));
});
CheckboxOption.displayName = 'CheckboxOption';
export { Checkbox };
export default CheckboxOption;